/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCube } from '../../factoriesAny.js';
export var cubeDependencies = {
  typedDependencies,
  createCube
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCube.generated.js
// module id = S8Tz
// module chunks = 3